import React from "react";

import { arrayMove } from "react-sortable-hoc";

import SortableList from "./SortableList";

function MoveTools({ drawerList, changeItemIndex }) {
    const onSortEnd = ({ oldIndex, newIndex }) => {
        changeItemIndex(arrayMove(drawerList, oldIndex, newIndex));
    };

    return <SortableList drawerList={drawerList} onSortEnd={onSortEnd} lockAxis="y" lockToContainerEdges={true} />;
}

export default MoveTools;
